export class AlertaModel {
    id: number;
    correoCopiaDestino: string;
    correoDestinoCambioEstado: string;
    correoDestinoNoCambioEstado: string;
    correoRemite: string;
    textoCorreo: string;
    nombre: number;
    isActivo: boolean;
}